import { http, HttpResponse, PathParams } from 'msw';
import { AccountApiPaths } from '../../../slices/account-api.slice';
import { apiUrl } from '../apiUrl';
import { phoneContact } from '../../data/contacts';
import { composeServerError, otpHandler, validatePasswordInSettingsFlow } from './shared';
import { tooManyAttemptsPhoneNumber } from '../../data/phone-number';

// update phone number
const verifyPasswordToUpdatePhone = http.post<PathParams, { password: string }>(
    apiUrl(AccountApiPaths.verifyPasswordToUpdatePhone),
    async ({ request }) => {
        const { password } = await request.json();
        const error = validatePasswordInSettingsFlow(password);
        return error ? composeServerError(request, error) : HttpResponse.json();
    }
);

const initUpdatePhone = http.post<PathParams, { number: string }>(
    apiUrl(AccountApiPaths.initUpdatePhone),
    async ({ request }) => {
        const { number } = await request.json();

        if (number === tooManyAttemptsPhoneNumber) {
            return HttpResponse.json(
                {
                    error: 'Bad Request',
                    errorCode: 'UPC-1006',
                    message: 'Too many OTP attempts. Try again in five minutes'
                },
                { status: 400 }
            );
        }

        return HttpResponse.json({ contactId: phoneContact.contactId });
    }
);

const updatePhoneVerifyOtp = http.post(apiUrl(AccountApiPaths.updatePhoneVerifyOtp), otpHandler);

export const phoneHandlers = [updatePhoneVerifyOtp, verifyPasswordToUpdatePhone, initUpdatePhone];
